import { Navbar } from "react-bootstrap";
import * as Action from "../state/actions/Actions";
import { useDispatch } from "react-redux";
import { FaLock } from "react-icons/fa";
import { RollingResourceLinkTooltipComponent } from "./toolTipComponent/RollingResourceLinkTooltipComponent";

interface SearchResultItemProps {
  title: string;
  urlObject: { Description: string; Url: string };
  img: string;
  protected: boolean;
}

const SearchResultItem: React.FC<SearchResultItemProps> = (
  props: SearchResultItemProps
) => {
  const dispatch = useDispatch();

  const lowerCaseKeyWord = props.title;
  const safeKeyWord = lowerCaseKeyWord ?? "";
  const resultItemHeading =
    safeKeyWord.charAt(0).toUpperCase() + safeKeyWord.slice(1);

  const handleItemClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const id = event.currentTarget.getAttribute("id");
    if (id) {
      dispatch(Action.setClickedItem(id));

      dispatch(Action.searchStatisticsSaga(id));
    }
  };

  return (
    <div id={props.title} onClick={handleItemClick}>
      <Navbar className="bg-body-tertiary !py-2">
        <div
          style={{
            width: "100%",
            padding: "5px",
            color: "rgb(44,43,43)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <a
            href={props.urlObject?.Url ?? props.urlObject}
            className="flex justify-between !text-[rgb(44,43,43)] !h-[30px] !no-underline hover:!underline"
          >
            <img
              alt={resultItemHeading}
              src={props.img}
              className="!mr-2 !w-[30px] "
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src =
                  "https://faneverydaywear.com.au/wp-content/uploads/2018/04/No-Image.jpg";
              }}
            />
            {[resultItemHeading]}
          </a>
          <RollingResourceLinkTooltipComponent content="Separat behörighet krävs" placement="top">
            <Navbar.Collapse className="justify-content-end">
              <Navbar.Text>{props.protected ? <FaLock /> : null}</Navbar.Text>
            </Navbar.Collapse>
          </RollingResourceLinkTooltipComponent>
        </div>
      </Navbar>
    </div>
  );
};

export default SearchResultItem;
